import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({
    endPoint: 'DossierFinder/DossierServiceRoleConfig',
    method: 'GET',
    body: null,
    token: token
  })
}
